module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Vincent’s Crazy Go-Kart Race")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1"
    }
  }, [_vm._v("Chapter 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-favorite-show"
    }
  }, [_vm._v("The Favorite Show")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-project-attack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Project Attack")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#a-visitor-from-nowhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Visitor from Nowhere")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#troublenothing-but-trouble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trouble—Nothing but Trouble")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-visit-to-fannings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Visit to Fanning’s")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chaos-in-the-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chaos in the Street")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#a-cocky-woman-with-a-frilly-skirt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cocky Woman with a Frilly Skirt")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-money-problem-grows-into-a-money-monster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Money Problem Grows into a Money Monster")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#a-dreadful-defeat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dreadful Defeat")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-visit-to-granddad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Visit to Granddad")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#a-dirty-and-dusty-bundle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dirty and Dusty Bundle")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-boot-nightmare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boot Nightmare")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#fitness-training-at-last",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fitness Training at Last")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#a-surprise-visit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Surprise Visit")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#vincents-training-routine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vincent’s Training Routine")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#rest-and-refresh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rest and Refresh")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#campaign-bungled",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Campaign Bungled")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#olli-disappears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Olli Disappears")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-race-rounds",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Race Rounds")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-race-finale",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Race Finale")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-award-ceremony",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Award Ceremony")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0